module.exports = __webpack_public_path__ + "static/api-launch-467a13518082231ca95f65bae5ae9a04.jpg";